import {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  FC,
  MouseEvent,
  ReactNode,
} from 'react'

import { TypeSize } from '@/core/types'
import { cn } from '@bem-react/classname'

import './Button.scss'

export type ButtonType = 'button' | 'submit'

export type ButtonColorType = 'purple' | 'dark' | 'light' | 'blue'

const cnButton = cn('Button')

export interface IButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children: ReactNode
  fluid?: boolean
  type?: ButtonType
  color?: ButtonColorType
  isLoading?: boolean
  iconPosition?: 'left' | 'right'
  size?: TypeSize
  icon?: boolean
  onClick?: (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  onMouseEnter?: (
    event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  ) => void
  onMouseLeave?: (
    event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  ) => void
}

export const Button: FC<IButtonProps> = ({
  disabled,
  isLoading,
  type = 'button',
  children,
  color = 'purple',
  fluid,
  size = 'xxl',
  className,
  id,
  iconPosition,
  onClick,
  onMouseEnter,
  onMouseLeave,
  icon,
}: IButtonProps) => {
  return (
    <button
      id={id}
      className={cnButton(
        {
          blue: color === 'blue',
          light: color === 'light',
          purple: color === 'purple',
          dark: color === 'dark',
          xxl: size === 'xxl',
          xl: size === 'xl',
          lg: size === 'lg',
          md: size === 'md',
          sm: size === 'sm',
          loading: isLoading,
          left: iconPosition === 'left',
          right: iconPosition === 'right',
          fluid,
          icon,
        },
        [className],
      )}
      type={type}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      disabled={disabled || isLoading}
    >
      {children}
    </button>
  )
}
